import type React from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const ErrorIcon: React.FC<Props> = ({ color }) => {
	const stroke = getColor(color);
	return (
		<svg
			role="img"
			aria-label="Error"
			width="28"
			height="25"
			viewBox="0 0 28 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.866 1.5001C14.4811 0.833408 13.5189 0.833406 13.134 1.5001L0.865968 22.75C0.481088 23.4167 0.962215 24.25 1.732 24.25H26.268C27.0378 24.25 27.5189 23.4167 27.134 22.75L14.866 1.5001Z"
				stroke={stroke}
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M14 22C15.1046 22 16 21.1046 16 20C16 18.8954 15.1046 18 14 18C12.8954 18 12 18.8954 12 20C12 21.1046 12.8954 22 14 22Z"
				stroke={stroke}
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M16.0195 8.63636C16.0195 7.73262 15.1241 7 14.0195 7C12.915 7 12.0195 7.73262 12.0195 8.63636V14.3636C12.0195 15.2674 12.915 16 14.0195 16C15.1241 16 16.0195 15.2674 16.0195 14.3636V8.63636Z"
				stroke={stroke}
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
		</svg>
	);
};
